export enum SourceDefinitionStatus {
  Success = 0,
  Failed = 1
}
